import { styled } from '@mui/material';

export const StyledErrorPageWrap = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	gap: '24px',
	padding: '8px 16px',
	textAlign: 'center',
	minHeight: '100%',

	[theme.breakpoints.down('sm')]: {
		gap: '12px',
	},
}));

export const StyledErrorPageImageWrap = styled('div')(({ theme }) => ({
	maxWidth: '456px',
	width: '100%',

	[theme.breakpoints.down('sm')]: {
		gap: '12px',
	},
}));

export const StyledErrorPageImage = styled('img')({
	width: '100%',
	maxWidth: '100%',
	objectFit: 'cover',
	aspectRatio: '57 / 50',
	borderRadius: '200px 200px 60px 60px',
});

export const StyledErrorPageTitle = styled('h1')(({ theme }) => ({
	fontWeight: '400',
	fontSize: '48px',
	lineHeight: '58px',
	margin: 0,

	[theme.breakpoints.down('sm')]: {
		fontSize: '32px',
		lineHeight: '38px',
	},
}));
